import { BaseConfigType } from './default';

const Config: BaseConfigType = {
  baseDomain: 'zigzag.kr',
  apiBaseUrl: 'https://api.zigzag.kr/api/store',
  redirectAppUrl: 'https://zigzag.kr',
  apiConsumerBaseUrl: 'https://api.zigzag.kr/api/2',
  appUrl: 'https://store.zigzag.kr',
  contentUrl: 'https://content.zigzag.kr',
  assetPrefix: `https://store.zigzag.kr/resources/${process.env.ARCH}/${process.env.IMAGE_TAG}_${process.env.WORKSPACE}`,
  payApiBaseUrl: 'https://api.zigzag.kr/api/user-pay',
  inlineImageLimit: 8192,
  localIdentName: '[hash:base64]',
  maintenanceDataUrl: 'https://s3.ap-northeast-2.amazonaws.com/ec.s.zigzag.kr/status/maintenance.json',
  simplePayPassword: 'https://api.zigzag.kr/api/security-keypad/static/js/simple_pay/simple_pay_password.js?t=20250314',
  simpleBankAppVersion: '6.6.0',
  sentry_dsn: 'https://9f80411ee6ed4d0c8c4701f476721cab@o314572.ingest.sentry.io/6037519',
  sentry_org: 'zigzag-production',
  resUrl: 'https://cf.res.s.zigzag.kr',
  feResUrl: 'https://cf.fe.s.zigzag.kr',
  zendeskRequestOrderItemNumberKey: '4540109294223',
  zendeskRequestOrderItemCsUrlKey: '4540097882127',
  csUrl: 'https://cs.zigzag.kr',
  business_juso_api_key: 'U01TX0FVVEgyMDIyMTEwNzEzMDEzMjExMzE5Mjg=',
  hackle_key: 'TkjLEPFTSOyUlA8GGWmCNkilhvBtDrfP',
  zigzag_postcode_url: 'https://store.zigzag.kr/postcode',
  zendesk_url: 'https://kakaostyle.zendesk.com/hc/p/requests-with-sso',
  zendesk_url_posty: 'https://posty-kakaostyle.zendesk.com/hc/p/requests-with-sso',
  kakao_rest_key: '9f5d80b8a7a81f07c75e57fb08f85792',
  kakao_app_key: '49c459f8302031e03cbeb78c87f05e1e',
  short_link_endpoint: 's.zigzag.kr',
  /** @description marketing start*/
  amplitude_id: 'b31370650d2a75565e9d1c17f0a08529',
  apps_flyer_pba_id: '83e876bb-2917-4557-8b76-bd7530f0f0c0',
  airbridge_app: 'zigzag',
  airbridge_web_token: '215f496de7984d60a7d4f50321419acd',
  naver_account_id: 's_dcb191a21ad',
  facebook_pixel_id: '1905064643463637',
  /** marketing end */
  toss_client_id: 'chtbtow1ovjqxw5gsq6qbjvldmfowg48',
  clarity_project_id: 'u3olzasyn7',
};

export default Config;
